const UKRAINIAN_LETTERS_REGEX = /^[а-щьюяґєіїА-ЩЬЮЯҐЄІІЇ\'\-\s]+$/;




// validationStep2.js
export const validateStep2 = (formData, isEdit = false) => {
  const errors = {};

  const control_code_rnokpp = [-1, 5, 	7, 	9, 	4, 	6, 	10,	5, 	7 ];

  const check_rnokpp = (string)=>{
    if(!string || string.length !== 10) return false;
    const sum = string.split("").slice(0,9).map(c=>+c).reduce((a,c,i)=>a + (c * control_code_rnokpp[i]), 0 );
    const rest = sum % 11;
    return +string[9] == rest;
  }

  // Валидация ФИО
  if (!formData.applicant.lastName || formData.applicant.lastName.trim() === '') {
    errors.applicantLastName = 'Прізвище обовʼязкове для заповнення';
  } else if (formData.applicant.lastName.trim().length < 2) {
    errors.applicantLastName = 'Прізвище має містити принаймні 2 символи';
  } else if (!UKRAINIAN_LETTERS_REGEX.test(formData.applicant.lastName)) {
    errors.applicantLastName = 'Прізвище має містити тільки українські літери, апостроф або дефіс';
  }

  if (!formData.applicant.firstName || formData.applicant.firstName.trim() === '') {
    errors.applicantFirstName = "Ім'я обовʼязкове для заповнення";
  } else if (formData.applicant.firstName.trim().length < 2) {
    errors.applicantFirstName = "Ім'я має містити принаймні 2 символи";
  } else if (!UKRAINIAN_LETTERS_REGEX.test(formData.applicant.firstName)) {
    errors.applicantFirstName = "Ім'я має містити тільки українські літери, апостроф або дефіс";
  }

  // По батькові не обов'язкове, але якщо заповнене - валідуємо
  if (formData.applicant.middleName && formData.applicant.middleName.trim() !== '') {
    if (formData.applicant.middleName.trim().length < 2) {
      errors.applicantMiddleName = 'По батькові має містити принаймні 2 символи';
    } else if (!UKRAINIAN_LETTERS_REGEX.test(formData.applicant.middleName)) {
      errors.applicantMiddleName = 'По батькові має містити тільки українські літери, апостроф або дефіс';
    }
  }

  // Валидация гражданства
  if (!formData.applicant.citizenship || formData.applicant.citizenship.trim() === '') {
    errors.applicantCitizenship = 'Громадянство обовʼязкове для заповнення';
  }

  // Валидация наличия РНОКПП
  if (!formData.applicant.hasRnokpp) {
    errors.applicantHasRnokpp = 'Оберіть наявність РНОКПП';
  } else if (formData.applicant.hasRnokpp === 'yes') {
    // Валидация РНОКПП
    if (!formData.applicant.rnokpp || formData.applicant.rnokpp.trim() === '') {
      errors.applicantRnokpp = 'РНОКПП обовʼязковий для заповнення';
    } else {
      const rnokppClean = formData.applicant.rnokpp.replace(/\D/g, '');
      
      if (rnokppClean.length !== 10) {
        errors.applicantRnokpp = 'РНОКПП має містити 10 цифр';
      } else if (!/^\d{10}$/.test(rnokppClean)) {
        errors.applicantRnokpp = 'РНОКПП має містити тільки цифри';
      } else {
        // Проверка контрольной цифры РНОКПП
        if (!check_rnokpp(rnokppClean)) {
          errors.applicantRnokpp = 'Невірний РНОКПП (помилка в контрольній цифрі)';
        }
      }
    }
  } else if (formData.applicant.hasRnokpp === 'no') {
    // Валидация для тех, у кого нет РНОКПП
    if (!formData.applicant.documentType || formData.applicant.documentType.trim() === '') {
      errors.applicantDocumentType = 'Оберіть тип документа';
    } else {
      if (!formData.applicant.documentDetails || formData.applicant.documentDetails.trim() === '') {
        errors.applicantDocumentDetails = 'Номер документа обовʼязковий для заповнення';
      } else {
        const docDetailsClean = formData.applicant.documentDetails.replace(/\s/g, '');
        
        if (formData.applicant.documentType === 'passport') {
          // Валидация паспорта (2 буквы + 6 цифр)
          if (!/^[A-ZА-ЯІЇЄ]{2}\d{6}$/.test(docDetailsClean)) {
            errors.applicantDocumentDetails = 'Паспорт має формат: 2 літери + 6 цифр (наприклад: СР123456)';
          }
        } else if (formData.applicant.documentType === 'idCard') {
          // Валидация ID карты (9 цифр)
          if (!/^\d{9}$/.test(docDetailsClean)) {
            errors.applicantDocumentDetails = 'ID картка має містити 9 цифр';
          }
        }
      }
    }
  }

  // Валидация телефона
  if (!formData.applicant.phone || formData.applicant.phone.trim() === '') {
    errors.applicantPhone = 'Телефон обовʼязковий для заповнення';
  } else {
    const phoneClean = formData.applicant.phone.replace(/\D/g, '');
    
    if (phoneClean.length < 10) {
      errors.applicantPhone = 'Телефон має містити принаймні 10 цифр';
    } else if (!/^(\+?38)?0\d{9}$/.test(phoneClean) && !/^\+?[1-9]\d{1,14}$/.test(formData.applicant.phone)) {
      errors.applicantPhone = 'Введіть коректний номер телефону';
    }
  }

  // Валидация email
  if (!formData.applicant.email || formData.applicant.email.trim() === '') {
    errors.applicantEmail = 'Електронна пошта обовʼязкова для заповнення';
  } else {
    const email = formData.applicant.email.trim();
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    
    if (!emailRegex.test(email)) {
      errors.applicantEmail = 'Введіть коректну електронну пошту';
    } else if (email.length > 100) {
      errors.applicantEmail = 'Електронна пошта не може перевищувати 100 символів';
    }
  }

  // Валидация адреса (объект с district, street, building, corpus)
  if (!formData.applicant.address || typeof formData.applicant.address !== 'object') {
    errors.applicantAddress = 'Адреса проживання обовʼязкова для заповнення';
  } else {
    const address = formData.applicant.address;
    
    if (!address.district || address.district.trim() === '') {
      errors.applicantAddress = 'Оберіть район';
    }
    
    if (!address.street || address.street.trim() === '') {
      errors.applicantAddress = 'Оберіть вулицю';
    }
    
    if (!address.building || address.building.trim() === '') {
      errors.applicantAddress = 'Оберіть будинок';
    }
    
    // corpus (корпус) не обязателен, так как может отсутствовать
  }

  // Дополнительные проверки согласованности
  if (formData.applicant.citizenship === 'Україна' && formData.applicant.hasRnokpp === 'no') {
    // Для граждан Украины рекомендуется иметь РНОКПП
    if (!errors.applicantHasRnokpp) {
      //errors.applicantHasRnokpp = 'Громадянам України рекомендується мати РНОКПП';
    }
  }

  // Проверка возраста заявителя (если есть дата рождения)
  if (formData.applicant.birthDate) {
    const birthDate = new Date(formData.applicant.birthDate);
    const currentDate = new Date();
    const age = currentDate.getFullYear() - birthDate.getFullYear();
    
    if (age < 18) {
      errors.applicantBirthDate = 'Заявник має бути повнолітнім';
    }
  }

  return errors;
};

// Функция для проверки контрольной цифры РНОКПП
const validateRnokppControlDigit = (rnokpp) => {
  if (rnokpp.length !== 10) return false;
  
  const digits = rnokpp.split('').map(Number);
  
  // Проверка контрольной цифры (последняя цифра)
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += digits[i] * (10 - i);
  }
  
  const controlDigit = sum % 11;
  const finalControlDigit = controlDigit === 10 ? 0 : controlDigit;
  
  return finalControlDigit === digits[9];
};

// Дополнительные утилиты для валидации
export const validateStep2Partial = (field, value, formData) => {
  const partialErrors = {};

  switch (field) {
    case 'applicant.lastName':
      if (!value || value.trim() === '') {
        partialErrors.applicantLastName = 'Прізвище обовʼязкове для заповнення';
      } else if (value.trim().length < 2) {
        partialErrors.applicantLastName = 'Прізвище має містити принаймні 2 символи';
      }
      break;

    case 'applicant.firstName':
      if (!value || value.trim() === '') {
        partialErrors.applicantFirstName = "Ім'я обовʼязкове для заповнення";
      } else if (value.trim().length < 2) {
        partialErrors.applicantFirstName = "Ім'я має містити принаймні 2 символи";
      }
      break;

    case 'applicant.phone':
      if (!value || value.trim() === '') {
        partialErrors.applicantPhone = 'Телефон обовʼязковий для заповнення';
      } else {
        const phoneClean = value.replace(/\D/g, '');
        if (phoneClean.length < 10) {
          partialErrors.applicantPhone = 'Телефон має містити принаймні 10 цифр';
        }
      }
      break;

    case 'applicant.email':
      if (!value || value.trim() === '') {
        partialErrors.applicantEmail = 'Електронна пошта обовʼязкова для заповнення';
      } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value.trim())) {
          partialErrors.applicantEmail = 'Введіть коректну електронну пошту';
        }
      }
      break;

    case 'applicant.rnokpp':
      if (formData.applicant.hasRnokpp === 'yes') {
        if (!value || value.trim() === '') {
          partialErrors.applicantRnokpp = 'РНОКПП обовʼязковий для заповнення';
        } else {
          const rnokppClean = value.replace(/\D/g, '');
          if (rnokppClean.length !== 10) {
            partialErrors.applicantRnokpp = 'РНОКПП має містити 10 цифр';
          }
        }
      }
      break;

    case 'applicant.address':
      if (!value || typeof value !== 'object') {
        partialErrors.applicantAddress = 'Адреса проживання обовʼязкова для заповнення';
      } else {
        if (!value.district || value.district.trim() === '') {
          partialErrors.applicantAddress = 'Оберіть район';
        } else if (!value.street || value.street.trim() === '') {
          partialErrors.applicantAddress = 'Оберіть вулицю';
        } else if (!value.building || value.building.trim() === '') {
          partialErrors.applicantAddress = 'Оберіть будинок';
        }
      }
      break;

    default:
      break;
  }

  return partialErrors;
};

// Функция для проверки готовности шага
export const isStep2Ready = (formData) => {
  const errors = validateStep2(formData);
  return Object.keys(errors).length === 0;
};

// Функция для проверки конкретного поля адреса
export const validateAddressField = (field, value, address) => {
  const partialErrors = {};
  
  switch (field) {
    case 'district':
      if (!value || value.trim() === '') {
        partialErrors.district = 'Оберіть район';
      }
      break;
      
    case 'street':
      if (!value || value.trim() === '') {
        partialErrors.street = 'Оберіть вулицю';
      }
      break;
      
    case 'building':
      if (!value || value.trim() === '') {
        partialErrors.building = 'Оберіть будинок';
      }
      break;
      
    case 'corpus':
      // corpus не обязателен
      break;
      
    default:
      break;
  }
  
  return partialErrors;
};